//#region src/transports/registerInitial.ts
function registerInitialTransports(faro) {
	faro.transports.add(...faro.config.transports);
	faro.transports.addBeforeSendHooks(faro.config.beforeSend);
}
//#endregion
export { registerInitialTransports };

//# sourceMappingURL=registerInitial.js.map